// External dependencies
import moment from 'moment';

// Internal dependencies
import { calculateTrendline } from '../../../../services/trendline';
import { scaleORF } from '../scaling';

// grade_level is an integer: [0, 1, 2, 3] for grades K-3
// Note that "grade" is a string in the graphQL schema
// and is treated as a string in trendline.js and the all_percentiles object
export function generateProgressReportTrendline(data, scale, grade_level,locale) {

  const fall_months = [7,8,9,10];
  const winter_months = [11,0,1,2];
  const spring_months = [3,4,5,6];

  // if there is no grade for student, then turn trendline off
  if(!grade_level && grade_level != 0) {
    return [];
  }

  if(grade_level > 6) grade_level = 6;

  // trendline will get generated no matter what. With fewer data points,
  // Bayesian prior from benchmarks will dictate slope. With more observations,
  // data have increasing influence on shape of trend line

  let n_points = data.length
  let month_of_last_activity = moment(data[n_points-1].date).month()

  let season = "undefined"
  if(fall_months.includes(month_of_last_activity) == true) {
    season = "fall";
  }

  if(winter_months.includes(month_of_last_activity) == true) {
    season = "winter";
  }

  if(spring_months.includes(month_of_last_activity) == true) {
    season = "spring";
  }

  if (season == "undefined") {
    console.log("Month of activity does not align with season data")
  }

  // Generate a list of days on which we want to see a trend.
  let endYear = moment().year();
  if(moment().month() > 6) {
    endYear = endYear + 1;
  }

  const firstActivityDate = moment(data[0].date);
  const trendEndDate = moment("07-25-"+endYear, "MM-DD-YYYY").valueOf();

  let activityDate = firstActivityDate;
  let outputDates = [];
  let counter = 0;
  while(activityDate <= trendEndDate) {
    activityDate = moment(firstActivityDate).clone().add(counter, 'days').valueOf();
    outputDates.push(activityDate);
    counter++;
  }

  let dateScorePairs;
  let inputScale = scale;

  dateScorePairs = data.map(datapoint => [datapoint.date,datapoint.score]);

  // clean dateScorePairs of any null scores
  dateScorePairs = dateScorePairs.filter(pair => Array.isArray(pair) && pair.length > 1 && pair[1] !== null);

  let trendline =  calculateTrendline(dateScorePairs, outputDates, inputScale, season, grade_level, locale);

  // handle max scores for ESRI and PSF and NWF
  if(scale == 'ESRI' || scale == 'PSF' || scale == 'NWF') {
    trendline = trendline.map(point => {
      let score = point[1];
      if(score > 100) {
        score = 100;
      }
      return [point[0],score];
    });
  }
  return trendline;
}

function generateSmoothedTrendline(trendline) {
  let lastPoint = trendline.pop();
  let smoothedTrendline = [trendline[0]];
  for(let i = 1; i < trendline.length; i++) {
    if(trendline[i][1] != trendline[i - 1][1]) {
      smoothedTrendline.push(trendline[i]);
    }
  }
  smoothedTrendline.push(lastPoint);
  return smoothedTrendline;
}



export default {
  generateProgressReportTrendline,
}
